let _ = t => t,
  _t;
import clsx from 'clsx';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultSizes = {
  sm: [16, 1.33],
  md: [20, 1.5],
  lg: [24, 2]
};
const getStrokeWidth = (strokeWidth, size) => {
  if (strokeWidth) return strokeWidth;
  if (size in defaultSizes) return defaultSizes[size][1];
  if (size >= defaultSizes.lg[0]) return defaultSizes.lg[1];
  if (size >= defaultSizes.md[0]) return defaultSizes.md[1];
  return defaultSizes.sm[1];
};

/**
 * Basic tabler icon component (to be used only for creating a new icon in createTablerIcon).
 */
function TablerIcon({
  name,
  className: customClassName,
  size = 'md',
  strokeWidth,
  style,
  viewBox = '0 0 24 24',
  strokeLinecap = 'round',
  strokeLinejoin = 'round',
  stroke,
  color,
  forwardedRef,
  ...rest
}) {
  return /*#__PURE__*/_jsx("svg", {
    className: clsx(`icon icon-tabler icon-tabler-${name}`, size in defaultSizes && `icon-tabler-${size}`, customClassName),
    ...(size in defaultSizes ? {
      style: strokeWidth ? {
        strokeWidth,
        ...style
      } : style
    } : {
      style: {
        width: size,
        height: size,
        strokeWidth: getStrokeWidth(strokeWidth, size),
        ...style
      }
    }),
    viewBox: viewBox,
    stroke: stroke || 'currentColor',
    color: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    ref: forwardedRef,
    ...rest
  });
}
export default styled(TablerIcon)(_t || (_t = _`
    flex-shrink: 0;

    &.icon-tabler {
        fill: none;

        ${0}
    }
`), Object.entries(defaultSizes).reduce((acc, [key, [size, strokeWidth]]) => `${acc}
            &.icon-tabler-${key} {
                width: ${size}px;
                height: ${size}px;
                stroke-width: ${strokeWidth}px;
            }
        `, ''));